module.exports = __webpack_public_path__ + "static/encounter-scheduling-1-9a09be849131e6a0618df65cd9a90a02.png";